import { Box, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { useLogin } from '_api';
import { InitialRouteMap, PatientRouteMap } from '_constants';
import { SEVERITY } from '_constants/derived';
import { TextButton } from 'components/atoms';
import { AlertMessage } from 'components/molecules';
import { LoginForm } from 'components/organisms/forms';
import { MultiFactorAuth } from 'components/templates';
import React, { useState } from 'react';
import { useNavigateTo } from 'utils';

import { LoginPaper } from './styles';
import { AuthProps } from './types';

export const Login = () => {
  const navigate = useNavigateTo();
  const { mutateAsync: login } = useLogin();
  const [errorMessage, setErrorMessage] = useState('');
  const [auth, setAuth] = useState<AuthProps | undefined>(undefined);

  const submit = ({ username, password }: AuthProps, mfaCode?: string) => {
    return login({ username, password, mfaCode })
      .then((result) => {
        if (result.account.id && result.account.accountType !== 'GUARDIAN') {
          if (result.account.status === 'AWAITING_ACTIVATION') {
            navigate(InitialRouteMap.CHANGEPASSWORD);
          } else {
            navigate(PatientRouteMap.TABLE);
          }
        } else {
          setErrorMessage('Unexpected error occured.');
        }
      })
      .catch(async (error) => {
        if (error.response) {
          const { code, message }: { code: number; message: string } =
            error.response.data;
          if (
            code === 500 &&
            message
              .toLowerCase()
              .includes('an authentication code has been sent to your email address')
          ) {
            if (auth != undefined) {
              setTimeout(
                () =>
                  setErrorMessage(
                    'Incorrect code. A new code as been sent to your email address.',
                  ),
                2000,
              );
            } else {
              setAuth({ username, password });
            }
          } else {
            setErrorMessage(message);
            setTimeout(() => setErrorMessage(''), 2000);
          }
        } else {
          setErrorMessage('Failure to login.');
          setTimeout(() => setErrorMessage(''), 2000);
        }
      });
  };
  const toForgotPassword = () => navigate(InitialRouteMap.FORGOTPASSWORD);
  return (
    <LoginPaper>
      <img src="/img/logo-sign-in.png" alt={''} style={{ maxWidth: '20%' }} />
      {auth !== undefined ? (
        <MultiFactorAuth auth={auth} onSubmit={submit} />
      ) : (
        <>
          <Box sx={{ textAlign: 'right', width: '100%' }}>
            <Typography color={red[500]} fontSize={'12px'}>
              * Required
            </Typography>
          </Box>
          <LoginForm onSubmit={submit} />
          <TextButton onClick={toForgotPassword} sx={{ width: '100%' }}>
            FORGOT PASSWORD
          </TextButton>
        </>
      )}
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={errorMessage}
      />
    </LoginPaper>
  );
};
